import { Table } from "antd";
import React, { FC } from "react";

interface IAggregatedProfitAndLossReportTableProps {
  columns: any;
  dataSource: any;
}

export const AggregatedProfitAndLossReportTable: FC<
  IAggregatedProfitAndLossReportTableProps
> = ({ columns, dataSource }) => {
  return (
    <Table
      columns={columns}
      bordered={true}
      dataSource={dataSource}
      pagination={false}
    />
  );
};
